export default __webpack_public_path__ + "static/media/grandtriumphbanner.c6dce085.webp";